<template src="./index.html"></template>
<script>
import { getdata } from './data';
export default {
	props: {
		overlength: {
			type: Number,
			default: ''
		},
		list: {
			felecInvoiceNo: '',
			docNo: '',
			invoiceStatus: [],
			processingStatus: [],
			invoiceType: [],
			purchaserName: '',
			drawDates: [],
			taxAmounts: [],
			taskBatchNo: '',
			executeDates: []
		}
	},
	data() {
		return {
			//表格
			size: '',
			headData: getdata().headData,
			tableData: [],
			pagination: getdata().pagination,
			tablekey: 0,
			shaidiag: false,
			outlist: [],
			//排序字段
			order: '',
			//排序顺序
			sort: ''
		};
	},
	components: {},
	created() {
		this.initialization();
	},
	methods: {
		//初始化
		initialization() {
			this.$nextTick(() => {
				let params = {};
				params.limit = this.pagination.pageSize;
				params.page = this.pagination.pageNum;
				params.sort = this.sort;
				params.order = this.order;
				params.param = this.list;
				this.$https.fetchPost('/schedule/summary/invoice/usageStatus/query', params).then(res => {
					this.tableData = res.data.data;
					this.pagination.total = res.data.count;
				});
			});
		},
		//切割时间
		clippingTime(Tiem) {
			if (Tiem) {
				//yyyy-MM-dd HH:mm:ss
				let yyyy = Tiem.slice(0, 4) + '-';
				let MM = Tiem.slice(4, 6) + '-';
				let dd = Tiem.slice(6, 8) + ' ';
				let HH = Tiem.slice(8, 10) + ':';
				let mm = Tiem.slice(10, 12) + ':';
				let ss = Tiem.slice(12, 14);
				return yyyy + MM + dd + HH + mm + ss;
			}else{
				return ""
			}
		},
		//表格体 排序
		sortchange(e) {
			if (e.order != null) {
				this.sort = e.order == 'ascending' ? 'ASC' : 'DESC';
				this.order = e.prop;
			} else {
				this.sort = '';
				this.order = '';
			}
			this.initialization();
		}, //筛选数组
		forSearchScreeningBox(obj) {
			this.list.invoiceStatus = obj.fapzt;
			this.list.invoiceType = obj.faplxdm;
			this.list.processingStatus = obj.naturalUpload;
			this.initialization();
		},
		currentChange(e) {
			this.pagination.pageNum = e;
			this.initialization();
		},
		sizechange(e) {
			this.pagination.pageSize = e;
			this.initialization();
		},
		//表格筛选
		closeshaidiag() {
			this.shaidiag = false;
		},
		confirmfilter(e) {
			localStorage.setItem('InScheduledTasksoutlist', JSON.stringify(e.nochooselist));
			localStorage.setItem('InScheduledTasksheadData', JSON.stringify(e.chooselist));
			this.headData = e.chooselist;
			this.outlist = e.nochooselist;
			this.shaidiag = false;
			this.$refs.tablebox.dout();
			this.tablekey++;
		}
	}
};
</script>
<style scoped>
@import url('./index.less');
</style>
